import { render } from "./layout-breadcrumb.vue?vue&type=template&id=899f05f4"
import script from "./layout-breadcrumb.vue?vue&type=script&lang=js"
export * from "./layout-breadcrumb.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__